import React, { Component } from "react";
import { connect } from "react-redux";
import { addToCart, saveCart, addToWishlist } from "../actions/cartActions";
import { showSuccess, showInfo } from "../common/iziToast";
import * as Icons from "../common/icons";
import { withTranslation } from 'react-i18next';
import ExtendedLink  from "../components/ExtendedLink";

class CartActions extends Component {
    state = { defaultQuantity: 1 };

    onAddToCart = e => {
       
        let { t, product, stockItemId, originalPrice, specialPrice, quantity, loyaltyPoints, user } = this.props;
       
        if (!stockItemId || stockItemId === 0) { // get values from product if not passed as props (if not variations)
            stockItemId = product.stockItemId;
            originalPrice = product.originalPrice;
            specialPrice = product.specialPrice;
            quantity = this.state.defaultQuantity;
            loyaltyPoints = product.loyaltyPoints;
        }

        this.props.addToCart(product, quantity, originalPrice, specialPrice, stockItemId, loyaltyPoints);

        showSuccess( t("Add to cart"), `${t("successfuly added")} ${product.title} ${t("to your cart!")}`, Icons.CART );

        this.fireMarketingEvents();
    };


    onAddToWishList = e => {
        if (window.fbq) {
            window.fbq('track', 'AddToWishlist');
        }
       
        const { t, product } = this.props;
        this.props.addToWishlist(this.props.product);
        showInfo(
            t("Add to wishlist"),
            `${t("successfuly added")} ${product.title} ${t("to your wishlist!")}`,
            Icons.CART
        );
    };

    fireMarketingEvents = () => {
        let { product, quantity, settings } = this.props;

        if (window.fbq) {
            window.fbq('track', 'AddToCart',
                {
                    currency: settings.isoCurrencySymbol,
                    content_type: 'product',
                    value: product.specialPrice,
                    contents: [{
                        id: product.stockItemCode,
                        quantity: quantity
                    }]

                });
        }

        if (window.gtag) {
            window.gtag('event', 'add_to_cart', {
                currency: settings.isoCurrencySymbol,
                items: [{
                    item_id: product.stockItemCode,
                    item_name: product.title,
                    item_category: product.groupName,
                    price: product.specialPrice,
                    currency: settings.isoCurrencySymbol,
                    quantity: quantity
                }],
                value: product.specialPrice
            });
        }
    };

    render() {
        const { t, product, isDetailsView, stockItemId, settings } = this.props;
        if (!product || settings.isCatalogueMode)
            return <div/>

        const productLink = `/products/${product.id}`;
        const canAddtoCart = (product.hasSingleStock || stockItemId > 0);
        let actionButton;
        if (product.hasSingleStock === false && stockItemId <= 0) {
            actionButton = (
                isDetailsView ? "" : <ExtendedLink
                    to={productLink}
                    title={product.title}
                    className="btn btn-outline-primary btn-sm" >
                                {t("View Options")}
        </ExtendedLink>
            );
        }
        return (
            <div className="product-buttons">
                <button
                    onClick={this.onAddToWishList}
                    className="btn btn-outline-secondary btn-sm btn-wishlist"
                    data-toggle="tooltip"
                    title={t("Wishlist")} >
                    <i className="icon-heart" />
                </button>
                <div className="d-inline-block" title={(canAddtoCart ? t("Add to cart") : t("NeedToSelectOptionFirst"))}>
                <button
                    onClick={this.onAddToCart}
                    className={ canAddtoCart ? "btn btn-outline-primary btn-sm" : "btn btn-outline-secondary btn-sm disabled-link"} >
                        {t("Add to cart")}
                    </button>
                 </div>
                {actionButton}
                {isDetailsView &&
                    (
                    <ExtendedLink to={`${settings.baseUrl}checkout`} className="btn btn-success btn-sm">
                                                        {t("Checkout")}
                    </ExtendedLink>)}
            </div>
        );
    }
}


function mapStateToProps({ settings, user,cart }, ownProps) {
    return { settings, user, cart, ...ownProps };
}


export default withTranslation()(connect(mapStateToProps, { addToCart, saveCart, addToWishlist })(CartActions));
